import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgItems = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3998 10.2C19.3898 10.2 20.9998 8.58998 20.9998 6.59998C20.9998 4.60998 19.3898 3 17.3998 3C15.4098 3 13.7998 4.60998 13.7998 6.59998C13.7998 8.58998 15.4098 10.2 17.3998 10.2Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.60001 10.2C8.59001 10.2 10.2 8.58998 10.2 6.59998C10.2 4.60998 8.59001 3 6.60001 3C4.61001 3 3 4.60998 3 6.59998C3 8.58998 4.61001 10.2 6.60001 10.2Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3998 21.0001C19.3898 21.0001 20.9998 19.3901 20.9998 17.4001C20.9998 15.4101 19.3898 13.8 17.3998 13.8C15.4098 13.8 13.7998 15.4101 13.7998 17.4001C13.7998 19.3901 15.4098 21.0001 17.3998 21.0001Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.60001 21.0001C8.59001 21.0001 10.2 19.3901 10.2 17.4001C10.2 15.4101 8.59001 13.8 6.60001 13.8C4.61001 13.8 3 15.4101 3 17.4001C3 19.3901 4.61001 21.0001 6.60001 21.0001Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
export default SvgItems;
